"use strict";

define('model/product',['./base'], function (Model) {
  var Product = Model.extend({
    urlRoot: '/rs/api/tenant/product'
  }, {
    SP_PRODUCT: 'SP'
  });
  return Product;
});

